<template>
  <v-container fluid class="wLightGray event-container">
    <v-row>
      <v-col cols="12">
        <h1 class="wc-h4 font-weight-bold">Ventas de membresías</h1>
        <p class="grey--text text--darken-1">
          Consulta y administra las ventas de los miembros de tu capítulo.
        </p>
      </v-col>

      <v-col v-if="loading" cols="12" md="8">
        <v-progress-linear indeterminate color="primary" rounded />
      </v-col>

      <v-col v-else-if="error" cols="12" md="8">
        <v-alert type="error" outlined>{{ error }}</v-alert>
      </v-col>

      <v-col v-else-if="affiliations.length === 0" cols="12" md="8">
        <v-alert type="info" outlined>
          El headoffice no tiene membresías activas disponibles para ventas.
        </v-alert>
      </v-col>

      <v-col
        v-for="affiliation in affiliations"
        :key="affiliation._id"
        cols="12"
        sm="6"
        lg="4"
      >
        <v-card class="rounded-lg" outlined>
          <v-img
            v-if="affiliation.banner"
            :src="affiliation.banner"
            height="150"
          />
          <v-card-title class="font-weight-bold">
            {{ affiliation.name || "Membresía" }}
          </v-card-title>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="primary"
              rounded
              @click="openSales(affiliation._id)"
            >
              Administrar ventas
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "ChapterMembershipSales",
  data: () => ({
    affiliations: [],
    loading: true,
    error: "",
  }),
  async created() {
    try {
      const { data } = await this.axios.get("/affiliations/chapter-sales");
      this.affiliations = data.affiliations || [];
    } catch (error) {
      this.error =
        error?.response?.data?.error?.message ||
        "No se pudo validar el acceso a las ventas del capítulo.";
    } finally {
      this.loading = false;
    }
  },
  methods: {
    openSales(affiliationId) {
      this.$router.push(`/mi-membresia/tickets-ventas/${affiliationId}`);
    },
  },
};
</script>

<style scoped>
.event-container {
  min-height: 93vh;
}
</style>
